import api from "../axios";

const getAccountId = () => sessionStorage.getItem("acc_id");

export async function getAllCaseManagers() {
  const tenantId = getAccountId();
  const response = await api.get(`/accounts/${tenantId}/case-managers/`);
  return response.data;
}

export async function getCaseManagerSummary(staff_id) {
  const tenantId = getAccountId();
  const response = await api.get(
    `/accounts/${tenantId}/case-managers/summary/`,
    {
      params: {
        staff_id,
      },
    }
  );
  return response.data;
}
